import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import config from 'config/api';
import isArray from 'mout/lang/isArray'
import DynamicForm from 'components/UI/DynamicForm';
import JobForm from 'components/UI/Job/JobForm';
import i18n from 'helpers/i18n';
import Immutable from 'immutable';
import merge from 'mout/object/merge';
import LoginForm from 'components/Login/LoginForm';
import ResetPasswordRequestForm from 'components/UI/ResetPassword/ResetPasswordRequestForm';
import { connect } from 'react-redux';
import ScrollToElementOnMount from 'components/UI/ScrollToElementOnMount';
import isMember from 'helpers/isMember';
// import SelectBlocks from 'components/UI/Form/SelectBlocks';

// import { subscribeToEvent, getSubscriptionState, clearSubscritionState } from 'components/UI/Event/ducks/event';
import { subscribeToEvent, getSubscriptionState } from 'components/UI/Event/ducks/event';
import { setCurrentUser, getCurrentUser } from 'components/UI/Account/ducks/authentication';


// const StyledSelectBlocks = withStyles(theme => ({
//   root: {
//     '& .MuiMenuItem-root': {
//       display: 'inline-block',
//       color: theme.palette.secondary.dark,
//       backgroundColor: 'transparent',
//       width: 200,
//       // marginRight: theme.spacing(2),
//     },
//     '& .MuiCheckbox-root': {
//       color: theme.palette.secondary.dark,
//     }
//   }
// }))(SelectBlocks)


const styles = (theme) => {
  return {
    root: {
      width: '100%',
      // color: theme.palette.primary.main,
      padding: '0 0 10px 0',
      // color: '#fff',
      '& .MuiTypography-body1': {
        // color: '#fff',
        '& a': {
          color: theme.palette.secondary.main
        }
      },
      '& .MuiTypography-h2': {
        // color: '#fff',
        fontSize: '2rem',
        [theme.breakpoints.down('md')]: {
          fontSize: '1.6rem',
        },
      },
      '& .MuiTypography-h4': {
        textAlign: 'center',
        color: theme.palette.primary.main,
        // fontWeight: 'bold',
        marginBottom: theme.spacing(4),
        [theme.breakpoints.down('md')]: {
          // fontSize: '1rem',
        },
      },
      '& .MuiTypography-h5': {
        // color: '#fff',
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
        },
      },
      '& .MuiTypography-h6': {
        // color: '#fff',
        textAlign: 'center',
      },
    },
    padderClass: {
      margin: '5px 0 20px'
    },
    formGroup: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      marginBottom: theme.spacing(8),
      position: 'relative',
      '&:before': {
        position: 'absolute',
        top: '-1%',
        left: '-1%',
        width: '102%',
        height: '102%',
        content: "''",
        border: '1px #ccc solid',
        zIndex: -1
      },
      '&.noMargins': {
        marginBottom: 0,
        paddingBottom: 0,
      }
      // '&:nth-of-type(3)': {
      //   paddingTop: 0,
      //   marginTop: theme.spacing(-2),
      //   marginBottom: theme.spacing(-2),
      //   paddingBottom: 0,
      //   '&:before': {
      //     display: 'none'
      //   }
      // }
    },
    mainForm: {
      maxWidth: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingTop: 1,
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    jobForm: {
      maxWidth: 440,
      display: 'block',
      margin: '0 auto'
    },
    whiteBg: {
      position: 'relative',
      '&:before': {
        position: 'absolute',
        left: 0,
        top: 0,
        content: "' '",
        width: '100%',
        height: '100%',
        // backgroundColor: '#fff',
        backgroundColor: theme.palette.background.paper,
        opacity: 0.9,
      },
    },
    relative: {
      position: 'relative',
    },
    column: {
      // height: '375px',
      // height: '280px',
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      height: 'auto',
      position: 'relative',
      '&:before': {
        position: 'absolute',
        top: '1%',
        left: '1%',
        width: '98%',
        height: '98%',
        content: "''",
        border: '1px #ccc solid',
        zIndex: -1
      },
      '& .MuiTypography-h5': {
        marginBottom: theme.spacing(3),
      },
      // [theme.breakpoints.down('sm')]: {
      //   paddingBottom: theme.spacing(6),
      // },
      // '&:nth-of-type(1)': {
      //   [theme.breakpoints.down('sm')]: {
      //     borderRight: 'none',
      //     borderBottom: '1px #ccc solid',
      //     borderTop: '1px #ccc solid',
      //   },
      // },
    },
    columnSmall: {
      height: '315px',
      '&:nth-of-type(1)': {
        borderRight: '1px #ccc solid',
        [theme.breakpoints.down('sm')]: {
          borderRight: 'none',
          borderBottom: '1px #ccc solid',
          borderTop: '1px #ccc solid',
        },
      },
    },
    columnPadder: {
      // display: 'flex',
      position: 'relative',
      // height: '100%',
      width: 'calc(100% - 20px)',
      marginRight: 10,
      marginLeft: 10,
    },
    padder: {
      padding: '20px 40px',
      margin: '0 30px 20px',
    },
    // h2: {
    //   color: theme.palette.primary.main,
    //   textAlign: 'center',
    //   padding: '0 20px 20px',
    //   [theme.breakpoints.down('sm')]: {
    //     fontSize: '20px',
    //   },
    // },
    h5: {
      textAlign: 'center',
    },
    h6: {
      fontWeight: 'normal',
    },
    body1: {
      textAlign: 'center',
    },
    recap: {
      '& a': {
        color: theme.palette.primary.main,
      },
    },
    formTitle: {
      textAlign: 'center',
      // color: theme.palette.primary.main,
      // color: '#fff',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      // [theme.breakpoints.down('sm')]: {
      // fontSize: '18px',
      // },
    },
    formSubTitle: {
      paddingTop: theme.spacing(3),
      color: theme.palette.tertiary.main,
    },
    passwordReset: {
      marginTop: theme.spacing(3),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
  };
};
class RegistrationTwoStepsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // isFormComplete: true,
      // showRecap: false,
      logMessage: false,
      isVerified: false,
      step: props.step ? props.step : 1,
      popinOpen: true,
      accountCategories: [],
      accountEventCategory: []
    };
  }
  componentDidMount() {
    if (this.props.$$subscriptionState === 'complete')
    {
      // console.log('$$subscriptionState changed !')
      this.setState({step: 3});
    }
    // console.log('mounted RegistrationTwoStepsForm')
  }
  componentDidUpdate(oldProps) {
    if (oldProps.$$subscriptionState !== 'complete' && this.props.$$subscriptionState === 'complete')
    {
      // console.log('$$subscriptionState changed !')
      // this.setState({step: 3});
      this._onFormComplete()
    }
  }
  componentWillUnmount() {
    // const {clearSubscritionState} = this.props;
    // clearSubscritionState();
  }
  _onRegistrationCancel = () => {
    if (this.props.onFormCanceled) {
      this.props.onFormCanceled()
    } else {
      this.setState(
        {
          accountJob: undefined,
          step: 1,
          isNewMember: false,
        },
        () => {
          if (this.props.onResize)
          this.props.onResize();
        },
      );
    }
  };
  _onLoginFormComplete = (r) => {
    // console.log('RegistrationTwoStepsForm _onLoginFormComplete')
    const { subscribeToEvent, $$event, $$events } = this.props;
    let ef = []
    // console.log('$$event',$$event)
    // console.log('$$events', $$events)
    if ($$event !== undefined && $$event.get('id') !== undefined)
    ef.push($$event.get('id'));
    else if ($$events !== undefined && $$events.size && $$events.get(0) !== undefined)
    ef = $$events.map((e) => e.get('id')).toArray();
    else if ($$events !== undefined && isArray($$events) && $$events[0] !== undefined)
    ef = $$events;
    // console.log('sending subscription with', ef.toJS())
    // console.log('calling subscribeToEvent')
    // console.log('loginFormComplete', $$event, $$events, ef)

    subscribeToEvent({$$events: Immutable.fromJS(ef), action: 'subscribe'});
  }
  _onRegistrationComplete = (r) => {
    // console.log('here is result', r)
    //     const {setCurrentUser} = this.props;
    // console.log('COMPLETE', r)
    //     setCurrentUser(r.user);
    // console.log('RegistrationTwoStepsForm _onRegistrationComplete')

    const { showRecap } = this.props;
    const { accountKind } = this.state;
    if (showRecap === true) {
    //   console.log('showing recap')
    // this.setState(
    //   {
    //     showRecap: true,
    //   },
    //   () => {
    //     if (this.props.onResize)
    //     this.props.onResize();
    //   },
    // );
    this.setState({
      accountJob: r.accountJob,
      isVerified: accountKind === 'rpps' || r.accountJob === 'lb',
      step: 5
    })

    } else {
      console.log('_onFormComplete')
      this.setState({accountJob: r.accountJob}, () => {
        this._onFormComplete(r);
      })
    }
    //     // this.setState({step: 3, newUserRole: r.accountJob});
  };
  _onToggleAccountCategory = (category) => {
    let currentCategories = this.state.accountCategories;
    // erase(currentCategories, category)
  };
  _onShowJobSelect = () => {
    this.setState(
      {
        step: 5,
      },
      () => {
        if (this.props.onResize)
        this.props.onResize();
      },
    );
  };
  _onRegisterWith = (kind) => {
    const {accountJob} = this.state;
    this.setState(
      {
        accountJob: kind === 'norpps' ? undefined : accountJob,
        accountKind: kind,
        step: 2,
        isNewMember: true,
      },
      () => {
        if (this.props.onResize)
        this.props.onResize();
      },
    );
  }
  _onJobFormComplete = (o) => {
    this.setState(
      {
        accountJob: o.values.accountJob,
        accountCategories: o.values.accountCategories,
        accountJobLabel: o.values.accountJobLabel,
        accountJobPrecision: o.values.accountJobPrecision,
        step: 2,
        accountKind: 'rpps',
        isNewMember: true,
      },
      () => {
        if (this.props.onResize)
        this.props.onResize();
      },
    );
  };
  _onLoginPasswordReset = () => {
    this.setState(
      {
        accountJob: undefined,
        step: 3,
      },
      () => {
        if (this.props.onResize)
        this.props.onResize();
      },
    );
  };
  _onFormComplete = () => {
    const { onClose, onFormComplete, closeOnComplete } = this.props;
    // console.log('BUBBLED !', onFormComplete)
    const { isNewMember, accountJob, accountKind } = this.state;

    const {$$event, $$events} = this.props;
    // console.log('RegistrationTwoStepsForm _onFormComplete')
    // console.log({
    //   logMessage,
    //   accountJob
    // })
    // console.log({accountKind, accountJob})
    if (onFormComplete === undefined) {
      if (onClose !== undefined) onClose();
    } else {
      onFormComplete({
        isNewMember: isNewMember,
        accountJob: accountJob,
        isVerified: accountKind === 'rpps' || accountJob === 'lb',
        $$event,
        $$events,
      });
      // console.log('b')
      if (closeOnComplete === true) {
        // console.log('c')
        onClose();
      }
    }
  };
  _closePopin = () => {
    this.setState({popinOpen: false});
  }
  _toggleAddressChoice = (k, rows) => {
    // console.log('should precise', k, rows)
    // const {precisions} = this.state;
    // this.setState({
    //   precisions: {
    //     ...precisions, {[k]: rows}
    //   }
    // })
    //
  }
  _onAccountEventCategoryChange = (kind, o) => {
    this.setState({accountEventCategory: kind})

  }
  render() {
    const {
      // onClose,
      classes,
      $$event,
      $$events,
      onResize,
      title,
      $$user,
      showLogin,
      scrollOnMount,
      key,
      // availableEventCategories,
      // showRecap,
      // extraFields,
    } = this.props;
    //
    const {
      // isFormComplete,
      // isNewMember,
      // logMessage,
      // showRecap,
      accountJob,
      accountCategories,
      accountKind,
      accountJobLabel,
      accountJobPrecision,
      accountEventCategory,
      isVerified,
      $$extraFields,
      step,
      // logMessage,
      // popinOpen,
    } = this.state;
    const moduleConfig = {
      module: 'account',
      fetchUrl: config.registration + '/edit',
      postUrl: config.registration + '/edit',
      redirectAfterEdit: false,
      afterEdit: 'onFormComplete',
      afterEditLog: '',
      afterEditHideForm: true,
      btCancel: true,
      onFormCancel: this._onRegistrationCancel,
      btCancelLabel: 'Retour',
      btSubmitLabel: 'Envoyer',
      buttonVariant: 'contained',
      formPrecisions: {
        // does nothing
        addressChoice: this._toggleAddressChoice
      },
      captcha: accountKind === 'norpps'
    };
    // const hiddenFields = $$user !== undefined && $$user.get('role') === 'admin'  ? [] : ['accountJob'];
    const hiddenFields = accountKind !== undefined && accountKind === 'rpps'  ? ['accountJob', 'accountJobPrecision'] : [];
    // const hiddenFields = [];
    // const jobCategories = config.getJobsCategories();
    const jobCategory = accountCategories === undefined ? [] : accountCategories;

    let ef = {};
    if ($$event !== undefined && $$event.get('id') !== undefined)
    ef = {
      fromEvent: $$event.get('id'),
    };
    else if ($$events !== undefined && $$events.size && $$events.get(0) !== undefined)
    ef = {
      fromEvents: $$events.map((e) => e.get('id')).toArray(),
    };
    else if ($$events !== undefined && isArray($$events) && $$events[0] !== undefined)
    ef = {
      fromEvents: $$events,
    };
    // if ($$extraFields) ef = merge(ef, $$extraFields)
    if (accountEventCategory.length > 0)
      ef.accountEventCategory = accountEventCategory;
    if (accountJob !== undefined)
    ef.accountJob = accountJob;
    if (accountJobPrecision !== undefined && accountJobPrecision !== null)
    ef.accountJobPrecision = accountJobPrecision;
    ef.accountCategories = accountCategories;

    // if(availableEventCategories)
    //   ef.accountEventCategory = accountEventCategory
    const extraFields = Immutable.fromJS(ef);
    // console.log('DEBUG', $$event, $$events);
    const userRole = $$user !== undefined ? $$user.get('role') : false;
    const userJob = $$user !== undefined ? $$user.get('job') : false;

    // console.log('ef is', extraFields.toJS())
    // console.log({jobCategory, hiddenFields, extraFields: extraFields.toJS()})
    // console.log('subscriptionHasRppsAndJob', i18n.get('subscriptionHasRppsAndJob'))
    // console.log(accountJobLabel)
    return (
      <div className={classes.root} key={key}>

        <If condition={step === 1}>
          <If condition={scrollOnMount !== false}>
            <ScrollToElementOnMount />
          </If>
          <Grid container spacing={0}  style={{textAlign: showLogin !== false ? undefined : 'center'}}>
            <Grid item={true} xs={12}>
              <Box w={'100%'}>
                <If condition={userRole === 'member' || userRole === false || userRole === 'visitor'}>
                  <If condition={$$event !== undefined || $$events !== undefined}>
                  <Typography variant="h5" className={classes.formTitle} >
                    <If condition={$$event !== undefined || ($$events !== undefined && $$events.size === 1)}>
                      {i18n.get('subscriptionSelfTitleSingle')}
                    </If>
                    <If condition={$$events !== undefined && $$events.size > 1}>
                      {i18n.get('subscriptionSelfTitlePlural')}
                    </If>
                  </Typography>
                  </If>
                </If>
                <If condition={userRole === 'staff' || userRole === 'admin' || userJob === 'lb'}>
                  <Typography variant="h5">
                    ...
                  </Typography>
                </If>
              </Box>
            </Grid>
            <If condition={showLogin !== false}>
              <Grid item={true} xs={12} md={showLogin !== false ? 6 : false} className={clsx(classes.column)}>
                <Typography variant={'h5'} gutterBottom={true}>
                  {i18n.get('loginFormTitle')}
                </Typography>
                <LoginForm
                  onFormComplete={this._onLoginFormComplete}
                  onPasswordResetRequest={this._onLoginPasswordReset}
                  extraFields={extraFields}
                  showRequiredLegend={false}
                  />
              </Grid>
            </If>
            <Grid item={true} xs={12} md={showLogin !== false ? 6 : 12} className={clsx(classes.column)}>
{/*              <If condition={availableEventCategories !== undefined}>
              <Box mb={3}>
              <Typography variant="h4">{i18n.get('subscriptionSubTitle', {pretty: false})}</Typography>
              </Box>
<Box mb={3} maxWidth={440} style={{display: 'block', margin: '0 auto'}}>
                <StyledSelectBlocks id={'accountEventCategory'} name={'accountEventCategory'} showLabel={false} multiple={true} variant="outlined" label={'test'} value={accountCategories} options={Immutable.fromJS(availableEventCategories)} onChange={this._onAccountEventCategoryChange} />
              </Box>
            </If>*/}
              <If condition={showLogin !== false}>
                <Typography variant={'h5'} gutterBottom={true}>
                  {i18n.get('subscriptionHasRpps')}
                </Typography>
              </If>
              <JobForm
                className={classes.jobForm}
                userRole={undefined}
                onFormComplete={this._onJobFormComplete}
                showRequiredLegend={false}
                fieldsSet={1}
                extraFields={extraFields}
                />

              <Box align="center" w="100%">
                <Button color="secondary" onClick={() => this._onRegisterWith('norpps')}>{i18n.get('subscriptionHasNoRpps',{pretty: false})}</Button>
              </Box>
            </Grid>
          </Grid>
        </If>
        <If condition={step === 2}>
          <If condition={scrollOnMount !== false}>
            <ScrollToElementOnMount />
          </If>
          <Box>
            <If condition={accountKind === 'rpps'}>
              <Typography variant={'h5'} color="secondary" className={classes.formTitle}>
                {i18n.get('subscriptionHasRppsAndJob', {substitute: {'{job}': accountJobLabel}})}
              </Typography>
            </If>
            <If condition={accountKind !== 'rpps'}>
              <Typography variant={'h5'} color="secondary" className={classes.formTitle}>
                {i18n.get('subscriptionHasNoRpps')}
              </Typography>
            </If>
          </Box>
          <If condition={i18n.has('subscriptionFormInstructions') === true && accountKind === 'rpps'}>
            <Box className={classes.whiteBg} mb={4}>
              <Typography variant={'h6'} className={classes.h6} style={{ position: 'relative' }}>
                {i18n.get('subscriptionFormInstructions')}
              </Typography>
            </Box>
          </If>
          <Box align="left" className={clsx(classes.mainForm)}>
            <DynamicForm
              key={'form_'+accountKind}
              kind={accountKind}
              moduleConfig={moduleConfig}
              onFormReady={onResize}
              onFormComplete={this._onRegistrationComplete}
              formNotice={<React.Fragment>
                <Box w={'100%'} align="center" mt={-2} mb={2}>
                  <Typography variant="body1">{i18n.get('subscriptionFormNotice')}</Typography>
                </Box>
                <If condition={accountKind === 'rpps'}>
                  <Box w={'100%'} align="center">
                    <Button color="secondary" onClick={() => this._onRegisterWith('norpps')}>{i18n.get('subscriptionHasNoId',{pretty: false})}</Button>
                  </Box>
                </If>
              </React.Fragment>
              }
              formFooter={undefined}
              extraFields={extraFields}
              forceHiddenFields={hiddenFields}
              onFormCancel={this._onRegistrationCancel}
              initialCategories={jobCategory}
              groupClass={classes.formGroup}
              padderClass={classes.padderClass}
              />

            <If condition={i18n.has('registrationLogLegend1')}>
              <br />
              <Typography variant={'body1'} classes={{ root: classes.legend }} gutterBottom>
                {i18n.get('registrationLogLegend1', { prettyfy: true })}
              </Typography>
            </If>
            <If condition={i18n.has('registrationLogLegend2')}>
              <hr />
              <Typography variant={'body1'} classes={{ root: classes.legend }} gutterBottom>
                {i18n.get('registrationLogLegend2', { prettyfy: true })}
              </Typography>
            </If>
          </Box>
        </If>
        <If condition={step === 3}>
          <If condition={scrollOnMount !== false}>
            <ScrollToElementOnMount />
          </If>
          <div className={clsx(classes.passwordReset)}>
            <ResetPasswordRequestForm onFormCancel={this._onRegistrationCancel} />
          </div>
        </If>
        <If condition={step === 4}></If>
        <If condition={step === 5}>
          <If condition={scrollOnMount !== false}>
            <ScrollToElementOnMount />
          </If>
            <Grid item xs={12} className={classes.formWrapper}>
              <Box align="center" my={4}>
                  <If condition={isMember($$user)}>
                    <Typography variant="h5" component="div" color="secondary" align="center" gutterBottom>
                    {i18n.get('subscriptionMemberSuccessTitle', {pretty: true, element: 'div'})}
                  </Typography>
                  </If>
                  <If condition={!isMember($$user)}>
                    <If condition={isVerified === true}>
                      <Typography variant="h5" component="div" color="secondary" align="center" gutterBottom>
                      {i18n.get('subscriptionVerifiedSuccessTitle', {pretty: true, element: 'div'})}
                    </Typography>
                    </If>
                    <If condition={isVerified !== true}>
                      <Typography variant="h5" component="div" color="secondary" align="center" gutterBottom>
                      {i18n.get('subscriptionPendingSuccessTitle', {pretty: true, element: 'div'})}
                    </Typography>
                    </If>
                  </If>
                <Box mt={4}>
                  <Button variant="contained" color="primary" onClick={(e) => {e.preventDefault(); this.props.history.push('/')}}>{i18n.get('navHome')}</Button>
                </Box>
              </Box>
            </Grid>
          {/*<Grid container spacing={0} alignItems="center" justifyContent="space-around" style={{width: '100%'}}>
            <If condition={title !== undefined && title !== false}>
              <Grid item={true} xs={12}>
                <Box pb={2} mb={4}>
                  <If condition={userRole !== 'staff' && userRole !== 'admin' && userJob !== 'lb'}>
                    <Typography variant="h2" gutterBottom={true} >
                      {i18n.get('subscriptionSelfHasNoAccount', {pretty: true, element: 'div'})}

                    </Typography>
                  </If>
                  <If condition={userRole === 'staff' || userRole === 'admin' || userJob === 'lb'}>
                    <Typography variant="h2" gutterBottom={true} >
                      {i18n.get('subscriptionGuestitle', {pretty: true, element: 'div'})}

                    </Typography>
                  </If>
                </Box>
              </Grid>
            </If>
            <Grid item={true} xs={12} md={6} className={clsx(classes.columnSmall)}>
              <div className={clsx(classes.columnPadder)}>
                <If condition={userRole !== 'staff' && userRole !== 'admin' && userJob !== 'lb'}>
                  <Typography variant={'h5'} className={classes.formTitle} gutterBottom={true}>
                    {i18n.get('subscriptionSelfChoiceMdRPPS')}
                  </Typography>
                </If>
                <If condition={userRole === 'staff' || userRole === 'admin' || userJob === 'lb'}>
                  <Typography variant={'h5'} className={classes.formSubTitle} gutterBottom={true}>
                    <br />
                    {i18n.get('subscriptionGuestChoiceMdRPPS')}
                  </Typography>
                </If>
                <Box w="100%" align="center">
                  <Button variant="contained" color="secondary" onClick={() => this._onRegisterWith('rpps')}>{i18n.get('subscriptionAction',{pretty: false})}</Button>
                </Box>
                </div>
              </Grid>
              <Grid item={true} xs={12} md={6} className={clsx(classes.columnSmall)}>
                <div className={clsx(classes.columnPadder)}>
                  <If condition={userRole !== 'staff' && userRole !== 'admin' && userJob !== 'lb'}>
                    <Typography variant={'h5'} className={classes.formTitle} gutterBottom={true}>
                      {i18n.get('subscriptionSelfChoiceMdNoRPPS')}
                    </Typography>
                  </If>
                  <If condition={userRole === 'staff' || userRole === 'admin' || userJob === 'lb'}>
                    <Typography variant={'h5'} className={classes.formSubTitle} gutterBottom={true}>
                      <br />
                      {i18n.get('subscriptionGuestChoiceMdNoRPPS')}
                    </Typography>
                  </If>
                  <Box w="100%" align="center">
                    <Button variant="contained" color="secondary" onClick={() => this._onRegisterWith('norpps')}>{i18n.get('subscriptionAction',{pretty: false})}</Button>
                  </Box>

                  </div>
                </Grid>
              </Grid>*/}
            </If>
          </div>
        );
      }
    }
    const mapStateToProps = ($$state) => {
      return {
        $$user: getCurrentUser($$state),
        $$subscriptionState: getSubscriptionState($$state),
      };
    };
    const mapDispatchToProps = (dispatch) => {
      return {
        setCurrentUser: (user) => dispatch(setCurrentUser(user)),
        subscribeToEvent: (props) => dispatch(subscribeToEvent(props)),
        // clearSubscritionState: () => dispatch(clearSubscritionState()),
      };
    };
    export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RegistrationTwoStepsForm)));



// WEBPACK FOOTER //
// ./src/components/UI/Registration/RegistrationTwoStepsForm.jsx